module.exports = __webpack_public_path__ + "static/media/21ECLAC49.00300bc0.jpg";